/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Summary_SubtitlesInputs */



/**
* | output |
* | --- |
* | "Subtitles published." |
*
* @param {Iconik_Publish_Summary_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_summary_subtitles = /** @type {((inputs?: Iconik_Publish_Summary_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Summary_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Subtitles published.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Subtitles published.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Subtitles published.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Subtitles published.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtitles published.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Subtitles published.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Subtitles published.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Subtitles published.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Subtitles published.")
	return /** @type {LocalizedString} */ ("Subtitles published.")
});